<template>
  <div class="card" :class="{containerHalf: Object.keys(wargaObj).length !== 0, 'ems': $store.state.user.job === 'EMS', 'pemerintah': $store.state.user.job === 'Pemerintah'}">
    <div class="overlay" v-if="searchLoading">
      <div class="overlay__inner">
          <div class="overlay__content"><span class="spinner"></span></div>
      </div>
    </div>
    <h2>Data Warga</h2>
    <div class="input__container--alt">
      <input type="text" @keyup.enter="submitHandler()" class="data__input" placeholder="Cari..." v-model="searchQuery"/>
      <button class="data__submit" type="submit" @click.stop="submitHandler()">Submit</button>
    </div>
    <p v-if="showWarning" :class="{data__warning: showWarning}">Keyword pencarian minimal 3 huruf</p>
    <div class="list" :class="{'ems': $store.state.user.job === 'EMS', 'pemerintah': $store.state.user.job === 'Pemerintah'}">
      <ul>
        <li class="list__item" v-for="(data, i) in dataList" :key="data.identifier" @click="clickHandler(i)">
          <p>{{data.firstname}} {{data.lastname}}</p>
          <p class="small" v-if="data.metadata !== null">ID: {{JSON.parse(data.metadata).citizenid}}</p>
        </li>
      </ul>
    </div>
  </div>
  <div class="card card__middle" :class="{containerHalf: Object.keys(wargaObj).length !== 0, 'ems': $store.state.user.job === 'EMS', 'pemerintah': $store.state.user.job === 'Pemerintah'}">
    <div class="overlay overlay--alt" v-if="resultLoading">
      <div class="overlay__inner">
          <div class="overlay__content"><span class="spinner"></span></div>
      </div>
    </div>
    <h2 class="middle__h2">Warga</h2>
    <p>Last Edited by: {{editedBy}}</p>
    
    <div class="flex">
      <div class="flex__left">
        <img class="warga__placeholder" :src="!wargaObj.img ? '/img/avatar.jpg' : wargaObj.img" alt="placeholder image" />
        <img src="/img/upload-icon.svg" class="upload__button" v-if="!openUpload" @click="openUploadHandler()" />
        <input placeholder="Photo URL" class="photo__input" v-if="openUpload" v-model="imgSrc" type="text" />
        <button class="submit__button" v-if="openUpload" @click="handlePhotoSubmit(wargaObj.identifier, imgSrc)">Submit</button>
      </div>
      
      <div class="warga__input">
        <p>NIK</p>
        <input  :value="wargaObj.metadata === null || Object.keys(wargaObj).length === 0 ? '' : JSON.parse(wargaObj.metadata).citizenid" type="text" disabled />
        <p>Nama</p>
        <input :value="(wargaObj.firstname === null && wargaObj.lastname === null) || Object.keys(wargaObj).length === 0 ? '' : wargaObj.firstname + ' ' + wargaObj.lastname" type="text" disabled />
        <p>Tanggal Lahir</p>
        <input :value="wargaObj.dateofbirth === null || Object.keys(wargaObj).length === 0 ? '' : wargaObj.dateofbirth" type="text" disabled />
        <div class="warga__flex" v-if="$store.state.user.job === 'EMS' && Object.keys(wargaObj).length !== 0">
          <p class="warga__label">Golongan Darah</p>
          <img class="warga__img" v-if="!enableBloodEdit && $store.state.user.job === 'EMS'" src="/img/plus-sign.svg" alt="plus sign" @click="editHandler('blood')" />
          <img class="warga__img" v-if="enableBloodEdit && $store.state.user.job === 'EMS'" src="/img/save-icon.svg" alt="save sign" @click="saveBlood(wargaObj.identifier)" />
        </div>
        <p v-else>Golongan Darah</p>
        <input id="goldar" :value="Object.keys(wargaObj).length === 0 || wargaObj.goldar === '' ? '' : wargaObj.goldar ? wargaObj.goldar : 'Tidak Diketahui'" type="text" :disabled="!enableBloodEdit" />
        <div class="warga__flex" v-if="$store.state.user.job === 'Pemerintah' && Object.keys(wargaObj).length !== 0">
          <p class="warga__label">Nomor Telefon</p>
          <img class="warga__img" v-if="!enablePhoneEdit && $store.state.user.job === 'Pemerintah'" src="/img/plus-sign.svg" alt="plus sign" @click="editHandler('phone')" />
          <img class="warga__img" v-if="enablePhoneEdit && $store.state.user.job === 'Pemerintah'" src="/img/save-icon.svg" alt="save sign" @click="savePhone()" />
        </div>
        <p v-else>Nomor Telefon</p>
        <input id="phone" :class="{editable: enablePhoneEdit}" :value="wargaObj.phoneNumber === null || Object.keys(wargaObj).length === 0 ? '' : wargaObj.phone ? wargaObj.phone : 'Tidak Diketahui'" type="text" :disabled="!enablePhoneEdit" />
        <div class="warga__flex" v-if="$store.state.user.job === 'Pemerintah' && Object.keys(wargaObj).length !== 0">
          <p class="warga__label">Pekerjaan</p>
          <img class="warga__img" v-if="!enablePekerjaanEdit && $store.state.user.job === 'Pemerintah'" src="/img/plus-sign.svg" alt="plus sign" @click="editHandler('job')" />
          <img class="warga__img" v-if="enablePekerjaanEdit && $store.state.user.job === 'Pemerintah'" src="/img/save-icon.svg" alt="save sign" @click="savePekerjaan()" />
        </div>
        <p v-else>Pekerjaan</p>
        <input id="pekerjaan" :class="{editable: enablePekerjaanEdit}" :value="Object.keys(wargaObj).length === 0 ? '' : wargaObj.pekerjaan ? wargaObj.pekerjaan : 'Tidak Diketahui'" type="text" :disabled="!enablePekerjaanEdit" />
      </div>
    </div>
    <div class="flex__warga__container">
      <div class="flex__warga">
        <p class="notes__paragraph">Notes:</p>
        <img v-if="!enableNotesEdit" src="/img/plus-sign.svg" alt="plus sign" @click="editHandler('notes')" />
        <button v-if="enableNotesEdit" class="data__submit notes__submit" type="submit" @click.stop="notesSubmitHandler(wargaObj.identifier)">Submit</button>
      </div>
      
      <textarea id="notes" :disabled="!enableNotesEdit" class="notes__textarea"></textarea>
    </div>
    
  </div>
  <div class="card card--alt" :class="{hide: !openAdditionalInfo, 'ems': $store.state.user.job === 'EMS', 'pemerintah': $store.state.user.job === 'Pemerintah'}">
    <div class="card--alt__container">
      <div class="overlay overlay--alt" v-if="resultLoading">
        <div class="overlay__inner">
            <div class="overlay__content"><span class="spinner"></span></div>
        </div>
      </div>
      <div class="card__small">
        <div class="flex__warga">
          <h3 class="bubble__title">Lisensi</h3>
          <div>
            <img class="side__img" v-if="!enableLisensiEdit && $store.state.user.job === 'Polisi'" src="/img/plus-sign.svg" alt="plus sign" @click="editHandler('lisensi')" />
            <img class="warga__img side__img" v-if="enableLisensiEdit && $store.state.user.job === 'Polisi'" src="/img/save-icon.svg" alt="save sign" @click="lisensiSaveHandler(wargaObj.identifier)" />
          </div>
        </div>
        <p class="side__span">Last Edited By: {{lisensiEditedBy}}</p>
        <div class="bubble__container" v-if="!enableLisensiEdit">
            <p class="card__bubble tooltip" v-for="(lisensi, i) in lisensiArray" :key="i">{{lisensi.lisensi}} <span class="tooltiptext">Masa Berlaku: {{lisensi.masaBerlaku}}</span></p>
        </div>
        <div v-else class="lisensi__form">
            <select v-model="lisensi">
              <option value="SIM A">SIM A</option>
              <option value="SIM B">SIM B</option>
              <option value="SIM C">SIM C</option>
              <option value="SKCK">SKCK</option>
              <option value="Lisensi Senjata">Lisensi Senjata</option>
              <option value="BPJS">BPJS</option>
              <option value="Surat Kesehatan">Surat Kesehatan</option>
            </select>
            <input v-model="masaBerlaku" :class="{error: flagLisensiError}" class="lisensi__input" type="text" placeholder="Tanggal Berlaku" />
          </div>
      </div>
      <div class="card__small" v-if="$store.state.user.job === 'Pemerintah' || $store.state.user.job === 'Polisi'">
        <div class="flex__warga">
          <h3 class="bubble__title">Kendaraan</h3>
          <div>
            <img class="side__img" v-if="!enableKendaraanEdit && $store.state.user.job === 'Polisi'" src="/img/plus-sign.svg" alt="plus sign" @click="editHandler('kendaraan')" />
            <img class="warga__img side__img" v-if="enableKendaraanEdit && $store.state.user.job === 'Polisi'" src="/img/save-icon.svg" alt="save sign" @click="kendaraanSaveHandler(wargaObj.identifier)" />
          </div>
        </div>
        <p class="side__span">Last Edited By: {{kendaraanEditedBy}}</p>
        <p class="side__span" v-if="$store.state.user.roleId >= 3 && $store.state.user.job === 'Pemerintah'">Total Kendaraan: {{vehicleData.length}}</p>
        <p class="side__span" v-else>Total Kendaraan: {{kendaraanData.length}}</p>
        <div v-if="$store.state.user.roleId >= 3 && $store.state.user.job === 'Pemerintah'" class="bubble__container">
          <p class="card__bubble tooltip" v-for="(kendaraan, i) in vehicleData" :key="i">{{kendaraan.plate}} <span class="tooltiptext">{{kendaraan.modelname }}</span></p>
        </div>
        <div v-else-if="!enableKendaraanEdit" class="bubble__container">
          <p class="card__bubble tooltip" v-for="(kendaraan, i) in kendaraanData" :key="i">{{kendaraan.plate}} <span class="tooltiptext">{{kendaraan.modelname }}</span></p>
        </div>
        <div v-else class="lisensi__form kendaraan__form">
          <input v-model="platNomor" :class="{error: flagKendaraanError}" class="lisensi__input" type="text" placeholder="Plat Nomor" />
          <input v-model="modelName" :class="{error: flagKendaraanError}" class="lisensi__input" type="text" placeholder="Jenis Mobil" />
        </div>
      </div>
      <div class="card__small">
        <div class="flex__warga">
          <h3 class="bubble__title">History Document</h3>
          <div>
            <img class="side__img" v-if="$store.state.user.job === 'Pemerintah'" src="/img/plus-sign.svg" alt="plus sign" @click="addSuratHandler(wargaObj.identifier)" />
          </div>
        </div>
        <p class="side__span">Last Edited By: {{suratEditedBy}}</p>
        <div class="bubble__container">
          <p class="card__bubble surat__bubble" v-for="(surat, i) in suratData" @click.stop="suratClickHandler(surat.id, wargaObj.identifier, surat.surattitle)" :key="i">{{surat.surattitle}} <font-awesome-icon @click.stop="deleteSuratClickHandler(surat.id, wargaObj.identifier, surat.surattitle)" v-if="$store.state.user.job === 'Pemerintah'" icon="fa-solid fa-circle-xmark" class="delete-button"/></p>
        </div>
      </div>
      <div class="card__small">
        <h3 class="bubble__title">Rumah</h3>
        <div class="bubble__container">
        </div>
      </div>
      <div class="card__small" v-if="$store.state.user.job === 'EMS' && $store.state.user.roleId >= 11">
        <h3 class="bubble__title">Log Koma</h3>
        <p class="card__paragraph">Total koma minggu ini: {{ totalKoma.length }}</p>
        <!-- <p><span @click="komaHandler()" class="name__button">Tambah Catatan Koma</span></p> -->
        <p><span @click="catatanHandler()" class="name__button save--button">Lihat Catatan Koma</span></p>
      </div>
      <!-- <div class="card__small" v-if="$store.state.user.job === 'EMS' && $store.state.user.roleId >= 13">
        <h3 class="bubble__title">Total Koma</h3> -->
        <!-- <p><span @click="komaHandler()" class="name__button">Tambah Catatan Koma</span></p> -->
        <!-- <p><span @click="totalKomaHandler()" class="name__button save--button">Lihat Total Koma Minggu Ini</span></p>
      </div> -->
    </div>
  </div>
  <Transition name="fade">
    <div class="overlay-koma" v-if="showHistory">
      <div class="koma__container">
        <div class="form__control">
          <h3>History Koma</h3>
          <span class="close--button" @click="closeHandler('history')">X</span>
        </div>
        <p class="catatan__paragraph">Nama Pasien: {{ wargaObj.firstname }} {{ wargaObj.lastname }}</p>
        <div class="grid">
          <div class="cell cell--header">Date</div>
          <div class="cell cell--header">Alasan</div>
        </div>
        <div class="grid" v-for="(catatan, i) in totalKoma" :key="i">
          <div class="cell">{{catatan.date}}</div>
          <div class="cell">{{catatan.reason}}</div>
        </div>
      </div>
    </div>
  </Transition>
</template>
<script>
  import moment from 'moment';
  import SearchController from '../../Controller/SearchController.vue'
  export default {
    extends: SearchController,
    data() {
      return {
        searchQuery: "",
        dataList: [],
        wargaObj: {},
        imgSrc: '',
        openUpload: false,
        openAdditionalInfo: false,
        enableNotesEdit: false,
        notes: '',
        editedBy: '',
        currentIndex: -1,
        enablePhoneEdit: false,
        enablePekerjaanEdit: false,
        vehicleData: [],
        enableLisensiEdit: false,
        lisensi: 'SIM A',
        masaBerlaku: '',
        lisensiArray: [],
        flagLisensiError: false,
        lisensiEditedBy: '',
        enableKendaraanEdit: false,
        kendaraanEditedBy: '',
        platNomor: '',
        modelName: '',
        oldNotes: '',
        kendaraanData: [],
        showWarning: false,
        searchLoading: false,
        resultLoading: false,
        suratData: [],
        suratEditedBy: '',
        enableBloodEdit: false,
        totalKoma: [],
        alasanKoma: '',
        showKoma: false,
        showHistory: false,
      }
    },
    watch: {
      $route(to) {
        if(to.name === 'dashboard') {
          this.clickHandler(true)
        }
      }
    },
    mounted() {
      this.getWeeklyKoma()
        .then(result => {
          this.weeklyKomaArr = result
        })
    },
    methods: {
      reformatDate(date) {
        return moment(date).format('YYYY-MM-DD')
      }, 
      closeHandler(target) {
        if(target === 'koma') {
          this.showKoma = false;
        } else {
          this.showHistory = false;
        }
        
      },
      komaHandler() {
        this.showKoma = true;
        this.alasanKoma = '';
      },
      catatanHandler() {
        this.showHistory = true;
      },
      savePekerjaan() {
        const pekerjaan = document.getElementById('pekerjaan')
        if(pekerjaan.value !== this.wargaObj['pekerjaan']) {
          this.wargaObj['pekerjaan'] = pekerjaan.value
          this.updateEdited()
          this.postPekerjaan(this.wargaObj.identifier, pekerjaan.value, this.$store.getters['user/getFullName'], this.$store.state.user.job)
            .then(data => {
              if(data.status !== undefined && data.status === 201) {
                this.enablePekerjaanEdit = false;
              } else {
                console.error(data.msg)
              }
            })
        } else {
          this.enablePekerjaanEdit = false;
        }
      },
      updateEdited() {
        const jobEdit = this.$store.state.user.job === 'Pemerintah' ? 'Staff' : '';
        this.editedBy = jobEdit + " " + this.$store.getters['user/getFullName']
      },
      savePhone() {
        const phone = document.getElementById('phone')
        if(phone.value !== this.wargaObj['phone']) {
          this.wargaObj['phone'] = phone.value
          this.updateEdited()
          this.postPhone(this.wargaObj.identifier, phone.value, this.$store.getters['user/getFullName'], this.$store.state.user.job)
            .then(data => {
              if(data.status !== undefined && data.status === 201) {
                this.enablePhoneEdit = false;
              } else {
                console.error(data.msg)
              }
            })
        } else {
          this.enablePhoneEdit = false;
        }
      },
      editHandler(type) {
        if(Object.keys(this.wargaObj).length !== 0) {
          if(type === 'phone') {
            this.enablePhoneEdit = true;
          } else if(type === 'job') {
            this.enablePekerjaanEdit = true
          } else if(type === 'kendaraan') {
            this.enableKendaraanEdit = true
          } else if(type === 'notes') {
            this.enableNotesEdit = true
          } else if(type === 'lisensi') {
            this.enableLisensiEdit = true
          } else if(type === 'blood') {
            this.enableBloodEdit = true
          }
        }
      },
      submitHandler() {
        if(this.searchQuery.length >= 3) {
          this.searchLoading = true;
          this.showWarning = false;
          this.search(this.searchQuery)
          .then(result => {
            this.dataList = result.userData
            this.searchLoading = false;
          })
          this.currentIndex = -1;
        } else {
          this.showWarning = true;
        }
      },
      clickHandler(index) {
        if(index !== this.currentIndex || index === true) {
          if(typeof index !== 'boolean') {
            this.currentIndex = index
          }
          if(this.currentIndex !== -1) {
            this.resultLoading = true;
            this.wargaObj = this.dataList[this.currentIndex]
            this.openUpload = false;
            this.enableLisensiEdit = false;
            this.enableNotesEdit = false;
            this.enablePekerjaanEdit = false;
            this.enablePhoneEdit = false;
            this.enableLisensiEdit = false;
            this.enableBloodEdit = false;
            this.masaBerlaku = '';
            this.lisensi = 'SIM A';
            this.flagLisensiError = false;
            this.lisensiEditedBy = '';
            this.enableKendaraanEdit = false;
            this.platNomor = '';
            this.modelName = '';
            this.suratData = [];
            this.suratEditedBy = '';
            this.totalKoma = [];
            this.getImage(this.wargaObj.identifier)
            .then(data => {
              if(data.imageSrc.length !== 0) {
                this.wargaObj.img = data.imageSrc[0].imageSource
              }
            })
            const textarea = document.getElementById('notes')
            this.getDataWarga(this.wargaObj.identifier)
              .then(data => {
                if(data.dataWarga !== undefined) {
                  textarea.value = data.dataWarga.notes
                  this.oldNotes = data.dataWarga.notes
                  this.editedBy = data.dataWarga.editedBy
                  this.imgSrc = data.dataWarga.imageSource
                  this.wargaObj['pekerjaan'] = data.dataWarga.job
                  this.wargaObj['phone'] = data.dataWarga.phone
                  this.wargaObj['goldar'] = data.dataWarga.goldar
                } else {
                  textarea.value = ''
                  this.editedBy = ''
                  this.imgSrc = ''
                  this.wargaObj['pekerjaan'] = null
                  this.wargaObj['phone'] = null
                }
              })
            this.getLisensi(this.wargaObj.identifier)
              .then(data => {
                if(data.result !== undefined && data.lisensiResult !== undefined && data.lisensiResult.length > 0) {
                  this.lisensiArray = data.result
                  this.lisensiEditedBy = data.lisensiResult[0].editedBy
                } else {
                  if(data.msg !== undefined) {
                    console.error(data.msg)
                  } else {
                    this.lisensiArray = data.result
                  }
                }
              })
            this.getKendaraan(this.wargaObj.identifier)
              .then(data => {
                if(data.result !== undefined && data.kendaraanResult !== undefined && data.kendaraanResult.length > 0) {
                  this.kendaraanData = data.result
                  this.kendaraanEditedBy = data.kendaraanResult[0].editedBy
                } else {
                  if(data.msg !== undefined) {
                    console.error(data.msg)
                  } else {
                    this.kendaraanData = data.result
                  }
                }
              })
            this.getSurat(this.wargaObj.identifier)
              .then(data => {
                if(data.result !== undefined && data.result.length !== 0) {
                  if(this.$store.state.user.roleId >= 3) {
                    this.suratData = data.result
                  } else {
                    this.suratData = data.result.filter(name => name.surattitle === 'Kontrak Kerja' || name.surattitle === 'Surat Izin Opang' || name.surattitle === 'Surat Kartu Pekerja' || name.surattitle === 'Surat Magang');
                  }
                  

                }
              })
            this.getSuratEditedBy(this.wargaObj.identifier)
              .then(data => {
                if(data.result !== undefined && data.result.length !== 0) {
                  this.suratEditedBy = data.result[0].editedBy
                  this.resultLoading = false;
                } else {
                  this.resultLoading = false;
                }
              })
            if(this.$store.state.user.roleId >= 11 && this.$store.state.user.job === 'EMS') {
              this.getKoma(this.wargaObj.identifier)
                .then(data => {
                  if(data.result !== undefined) {
                    this.totalKoma = data.result;
                  }
                })
            }
            if(this.$store.state.user.roleId >= 3 && this.$store.state.user.job === 'Pemerintah') {
              this.getVehicle(this.wargaObj.identifier)
              .then(data => {
                if(data.result !== undefined) {
                  this.vehicleData = data.result
                }
              })
            }
            
            this.openAdditionalInfo = true;
          } 
        }
      },
      openUploadHandler() {
        if(Object.keys(this.wargaObj).length !== 0) {
          this.openUpload = !this.openUpload
        }
      },
      handlePhotoSubmit(steamHex, imgSrc) {
        if(this.imgSrc !== '' && imgSrc !== this.wargaObj.img) {
          this.wargaObj.img = this.imgSrc
          this.postImage(steamHex, imgSrc, this.$store.state.user.job, this.$store.getters['user/getFullName'])
          .then(data => {
            if(data.status === undefined) {
              console.log(data.msg)
            }
            this.updateEdited();
          })
        }
        this.openUpload = !this.openUpload
      },
      notesSubmitHandler(steamHex) {
        const textarea = document.getElementById('notes')
        this.postNotes(steamHex, textarea.value, this.$store.state.user.job, this.$store.getters['user/getFullName'], this.oldNotes)
          .then(data => {
            if(data.status !== undefined && data.status === 201) {
              this.enableNotesEdit = !this.enableNotesEdit
              this.oldNotes = textarea.value
            } else {
              console.error(data.msg)
            }
          })
      },
      lisensiSaveHandler(steamHex) {
        if(this.masaBerlaku !== '') {
          this.flagLisensiError = false;
          this.submitLisensi(steamHex, this.lisensi, this.$store.getters['user/getFullName'], this.$store.state.user.job, this.masaBerlaku)
          .then(data => {
            if(data.status !== undefined && data.status === 201) {
              this.enableLisensiEdit = !this.enableLisensiEdit
              this.lisensiArray.push({lisensi: this.lisensi, masaBerlaku: this.masaBerlaku})
              this.lisensiEditedBy = `${this.$store.state.user.job} ${this.$store.getters['user/getFullName']}`
              this.lisensi = 'SIM A';
              this.masaBerlaku = '';
            } else {
              console.error(data.msg)
            }
          })
        } else {
          this.enableLisensiEdit = !this.enableLisensiEdit
        }
      },
      kendaraanSaveHandler(steamHex) {
        if(this.platNomor !== '' && this.modelName !== '') {
          this.submitKendaraan(steamHex, this.platNomor, this.$store.getters['user/getFullName'], this.$store.state.user.job, this.modelName)
          .then(data => {
            if(data.status !== undefined && data.status === 201) {
              this.enableKendaraanEdit = !this.enableKendaraanEdit;
              this.kendaraanData.push({plate: this.platNomor, modelname: this.modelName})
              this.kendaraanEditedBy = `${this.$store.state.user.job} ${this.$store.getters['user/getFullName']}`
              this.platNomor = '';
              this.modelName = '';
            }
          })
        } else {
          this.enableKendaraanEdit = !this.enableKendaraanEdit
        }
      },
      addSuratHandler(steamHex) {
        this.$router.push(`/letter?action=new&steamHex=${steamHex}&warga_firstname=${this.wargaObj.firstname}&warga_lastname=${this.wargaObj.lastname}`);
      },
      suratClickHandler(id, steamHex, surattitle) {
        this.$router.push(`/letter?action=edit&surat_id=${id}&steamHex=${steamHex}&surattitle=${surattitle}`)
      },
      deleteSuratClickHandler(id, steamHex, surattitle) {
        this.deleteSurat(id, steamHex, this.$store.getters['user/getFullName'], this.$store.state.user.job, surattitle)
          .then(data => {
            if(data.status !== undefined && data.status === 204) {
              this.getSurat(this.wargaObj.identifier)
                .then(data => {
                  if(data.result !== undefined) {
                    if(this.$store.state.user.roleId >= 3) {
                      this.suratData = data.result
                    } else {
                      this.suratData = data.result.filter(name => name.surattitle === 'Kontrak Kerja' || name.surattitle === 'Surat Izin Opang' || name.surattitle === 'Surat Kartu Pekerja' || name.surattitle === 'Surat Magang');
                    }
                  }
                })
            } else {
              console.error(data.msg)
            }
          })
      },
      saveBlood(steamHex) {
        const goldar = document.getElementById('goldar')
        if(goldar.value !== this.wargaObj['goldar']) {
          this.postGoldar(steamHex, goldar.value, this.$store.getters['user/getFullName'])
          .then(data => {
            if(data.status !== undefined && data.status === 204) {
              this.wargaObj['goldar'] = goldar.value;
              this.enableBloodEdit = false;
            } else {
              this.enableBloodEdit = false;
              console.error(data.message)
            }
          })
        }
      },
    }
  }
</script>

<style>
  /* ANIMATION */
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.5s ease;
  }

  .fade-enter-from,
  .fade-leave-to {
    opacity: 0;
  }
  /* ALL STYLES */
  .koma__input:disabled {
    background: #dddddd;
  }
  .card, .card__small {
    margin-right: 10px;
    margin-top: 10px;
    height: 97%;
    margin-bottom: auto;
    margin-top: auto;
    width: 33%;
    overflow: hidden;
    position: relative;
  }
  .pemerintah.card, .pemerintah .card__small {
    background: #003D19;
  }
  .ems.card, .ems .card__small {
    background: rgb(90, 1, 1);
  }
  .card:hover {
    overflow-y: auto;
  }
  .card h2 {
    margin: 20px;
  }
  .card__container {
    padding: 20px;
    padding-top: 0;
  }
  .card:first-child {
    margin-left: 10px;
    overflow: hidden;
    overflow-y: auto;
  }
  .input__container--alt {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-left: 20px;
  }
  .input__container--alt input {
    width: 70%;
    margin-right: 20px;
    font-size: 1em;
    text-align: left;
  }
  .containerHalf {
    width: 33%
  }
  .containerHalf input {
    font-size: 1em
  }
  .flex {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 20px 0 10px;
  }
  .warga__placeholder {
    width: 140px;
    height: 175px;
  }
  .flex__left {
    max-width: 150px;
  }
  .flex__left button {
    display: block
  }
  .warga__input input {
    margin-bottom: 20px;
    width: 100%;
    padding: 0;
    margin-left: 0;
    margin-right: 0;
    text-align: left;
    color: #cdc8c8;
    border-color: #cdc8c8;
  }
  .editable {
    color: #fff !important;
    border-color: #fff !important;
  }
  .card h2 {
    font-size: 1.5em;
  }
  .card__middle {
    padding-left: 20px;
    padding-right: 20px;
    display: flex;
    flex-direction: column;
  }
  .data__input {
    text-align: center;
    padding: 0;
    margin: 0;
    margin-right: 20px;
  }
  .data__submit {
    margin-top: 0;
    font-size: 1em;
    width:75px;
    margin-right: 10px;
  }
  .list {
    padding-left: 20px;
    padding-right: 20px;
  }
  .list li {
    
    margin-bottom: 20px;
    padding: 10px 5px;
  }
  .list.pemerintah li {
    background: green;
  }
  .list.ems li {
    background: rgb(141, 2, 2);
  }
  .list li:first-child {
    margin-top: 20px;
  }
  .list li p {
    font-size: 2em
  }
  .list li p.small {
    font-size: 1em;
    margin-top: 10px;
  }
  .list__item {
    cursor: pointer;
  }
  .warga__input {
    margin-left: 20px;
    width: 65%
  }
  .upload__button {
    margin-left: auto;
    font-size: 1em;
    width: 30px !important;
    display: block;
    margin-top: 10px;
    cursor: pointer;
  }
  .photo__input {
    margin-top: 10px;
    width: 125px;
    padding: 10px;
    margin-left: 0;
    margin-right: 0;
  }
  .submit__button {
    margin-top: 20px;
    font-size: 1em;
    margin-left: auto;
  }
  .card--alt, .ems.card--alt, .pemerintah.card--alt {
    width: 33%;
    margin-bottom: auto;
    background: transparent;
    border: none;
  }

  .card--alt__container {
    margin-bottom: 12px;
    position: relative;
  }
  .card__small {
    margin-top: 0;
    height: fit-content;
    width: 100%;
    border: none;
    padding-bottom: 15px;
    margin-bottom: 10px;
  }
  .bubble__title {
    margin: 10px;
    margin-top: 0;
    padding-top: 15px;
    margin-left: 20px;
    font-size: 2em;
    margin-bottom: 0;
  }
  .bubble__container {
    display: flex;
    justify-self: flex-start;
    align-items: center;
    padding-left: 20px;
    flex-flow: wrap;
    padding-right: 10px;
  }
  .card__bubble {
    background: white;
    padding: 5px 15px;
    color: black;
    border-radius: 20px;
    margin-right: 10px;
    margin-top: 15px;
  }
  .hide {
    opacity: 0;
  }
  .show {
    opacity: 1;
  }
  .middle__h2 {
    margin-left: 0 !important;
  }
  .notes__textarea {
    height: 185px;
    width: 95%;
    background: transparent;
    color: white;
    padding: 10px;
    height: 80%;
    min-height: 150px;
    margin-bottom: 20px;
  }
  .notes__paragraph {
    margin-bottom: 5px;
  }

  .flex__warga {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .flex__warga__container {
    display: flex;
    flex-direction: column;
    height: 100%
  }
  .flex__warga img {
    width: 15px;
    cursor: pointer;
    margin-bottom: 5px;
  }
  .notes__submit {
    padding-top: 5px;
    padding-bottom: 5px;
    margin-bottom: 5px;
  }
  .warga__flex {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .warga__img {
    width: 15px;
    cursor: pointer;
  }
  .tooltip {
    position: relative;
  }
  .tooltip .tooltiptext {
  visibility: hidden;
  width: 120px;
  background-color: #555;
  color: #fff;
  text-align: center;
  padding: 5px 0;
  border-radius: 6px;

  /* Position the tooltip text */
  position: absolute;
  z-index: 1;
  bottom: 125%;
  left: 50%;
  margin-left: -60px;

  /* Fade in tooltip */
  opacity: 0;
  transition: opacity 0.3s;
}

/* Tooltip arrow */
.tooltip .tooltiptext::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: #555 transparent transparent transparent;
}

/* Show the tooltip text when you mouse over the tooltip container */
.tooltip:hover .tooltiptext {
  visibility: visible;
  opacity: 1;
}
.side__img {
  margin-right: 20px;
  margin-bottom: 0 !important;
  padding-top: 20px;
}
.lisensi__form {
  display: flex;
  align-items: center;
  justify-content: space-around;
  padding: 0 0 0 20px;
}
.lisensi__form select {
  border-radius: 5px;
  padding: 5px;
  margin-top: 5px;
  width: 35%;
  color: black;
}
.lisensi__form input {
  width: 50%;
  padding-left: 5px;
  text-align: center;
  margin: 0 auto;
  font-size: 1em;
}
.lisensi__form .error {
  border-color: red;
}
.side__span {
  margin: 10px 10px 0 20px;
}
.kendaraan__form input {
  width: 40%;
}
.kendaraan__form input:first-child {
  margin-left: 0
}
.data__warning {
  margin-left: 20px;
  color: red;
}
.surat__bubble {
  cursor: pointer;
}
.overlay {
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 5;
}

.overlay__inner {
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    position: absolute;
}

.overlay__content {
    left: 50%;
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
}

.spinner {
    width: 75px;
    height: 75px;
    display: inline-block;
    border-width: 2px;
    border-color: rgba(255, 255, 255, 0.05);
    border-top-color: #fff;
    animation: spin 1s infinite linear;
    border-radius: 100%;
    border-style: solid;
}
.overlay--alt {
  background: rgba(0,0,0,0.4)
}

.delete-button {
  color: #cf0000;
  margin-left: 10px;
}

.card__paragraph {
  margin: 15px 20px 0;
  font-size: 18px;
}

.name__button {
  background: red;
  padding: 10px 20px;
  font-size: 17px;
  display: inline-block;
  border-radius: 5px;
  margin-left: 20px;
  margin-top: 10px;
  vertical-align: middle;
  cursor: pointer;
  margin-bottom: 2px;
}

.hide {
  opacity: 0;
}

.overlay-koma {
  width: 100%;
  height: 100%;
  position: fixed;
  background: rgba(0,0,0,0.4);
  top: 0;
  left: 0;
  z-index: 10;
  transition: all 0.2s;
}

.koma__container {
  background: white;
  width: 50%;
  position: relative;
  text-align: left;
  top: 50%;
  left: 50%;
  /* bring your own prefixes */
  transform: translate(-50%, -50%);
  border-radius: 5px;
  padding: 20px;
}

.form__control {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-top: 10px;
}

.koma__container h3 {
  font-size: 25px;
}

.koma__container label, .koma__container input {
  font-size: 18px;
}

.koma__container label {
  width: 120px;
}

.koma__container h3, .koma__container input, .koma__container label {
  color: black;
}

.koma__container input {
  margin: 0 0 0 10px;
  border-radius: 5px;
  border: solid 1px black;
  font-size: 14px;
  padding: 20px 10px;
  width: 60%;
}

.close--button {
  color: black;
  font-weight: 700;
  position: absolute;
  top: 10px;
  right: 10px;
  font-size: 20px;
  cursor: pointer;
}

.button__control {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.discard--button {
  color: black;
  background: lightgray;
  transform: scale(0);
  transition: all 0.2s;
  margin: 0;
}

.show {
  opacity: 1;
  transform: scale(1);
}

.save--button {
  color: white;
  background: darkblue
}

.catatan__paragraph {
  color: black;
  margin: 10px 0;
}

.grid {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.cell {
  background: rgba(82, 0, 0, 0.6);
  color: white;
  padding: 20px;
  min-width: 150px;
  border: solid 1px #fff;
}

.cell:last-child {
  width: 100%;
}

.cell--header {
  background: rgb(90, 1, 1);
  color: white;
}

.cell--header:last-child {
  width: 100%
}

@keyframes spin {
  100% {
    transform: rotate(360deg);
  }
}
</style>